import React from 'react';
import { Card, Text, Metric, Flex, ProgressBar, Tab, TabGroup, TabList, TabPanel, TabPanels } from '@tremor/react';
import { ParkingStats, ParkingType } from '../../types';
import { parkingAreas } from '../../mockData';

interface ParkingOverviewProps {
  stats: ParkingStats;
}

const ParkingOverview: React.FC<ParkingOverviewProps> = ({ stats }) => {
  const parkingTypeColors = {
    [ParkingType.RENTED]: 'emerald',
    [ParkingType.PUBLIC]: 'amber',
    [ParkingType.DEDICATED]: 'blue',
  };

  // Helper function to get area name from ID
  const getAreaName = (areaId: string) => {
    const area = parkingAreas.find(a => a.id === areaId);
    return area ? area.name : areaId;
  };

  return (
    <div className="space-y-6">
      <Card className="p-4 bg-transparent">
        <Text className='text-contentColor font-medium text-lg'>Total Occupancy</Text>
        <Flex className="mt-2">
          <Metric><Text className="text-contentColor font-bold text-3xl">{stats.totalOccupied} / {stats.totalCapacity}</Text></Metric>
          <Text>{stats.occupancyRate}%</Text>
        </Flex>
        <ProgressBar value={stats.occupancyRate} color="blue" className="mt-3" />
      </Card>

      <Card>
        <Text className="text-contentColor font-medium text-lg">Parking Areas Breakdown</Text>
        <TabGroup>
          <TabList className="mt-8">
            <Tab>By Type</Tab>
            <Tab>By Area</Tab>
          </TabList>
          
          <TabPanels>
            <TabPanel>
              {Object.entries(stats.parkingTypeStats).map(([type, data]) => (
                <div key={type} className="mt-4">
                  <Flex>
                    <Text>{type} Parking</Text>
                    <Text>{data.occupied} / {data.capacity}</Text>
                  </Flex>
                  <ProgressBar 
                    value={data.rate} 
                    color={
                      parkingTypeColors[type as ParkingType] as 
                      'slate' | 'gray' | 'zinc' | 'neutral' | 'stone' | 'red' | 'orange' | 
                      'amber' | 'yellow' | 'lime' | 'green' | 'emerald' | 'teal' | 'cyan' | 
                      'sky' | 'blue' | 'indigo' | 'violet' | 'purple' | 'fuchsia' | 'pink' | 'rose'
                    }
                    className="mt-2" 
                  />
                </div>
              ))}
            </TabPanel>
            
            <TabPanel>
              {Object.entries(stats.areaStats).map(([areaId, data]) => (
                <div key={areaId} className="mt-4">
                  <Flex>
                    <Text>{getAreaName(areaId)}</Text>
                    <Text>{data.occupied} / {data.capacity}</Text>
                  </Flex>
                  <ProgressBar 
                    value={data.rate} 
                    color={data.rate > 90 ? 'red' : data.rate > 70 ? 'amber' : 'emerald'} 
                    className="mt-2" 
                  />
                </div>
              ))}
            </TabPanel>
          </TabPanels>
        </TabGroup>
      </Card>
    </div>
  );
};

export default ParkingOverview;